import { Component, OnInit } from "@angular/core";
import { ModalController, NavParams } from "@ionic/angular";
import { ApiService } from "src/app/services/api.service";
import { WalletHelperService } from "src/app/services/wallet-helper.service";

@Component({
  selector: "app-select-staking-wallet",
  templateUrl: "./select-staking-wallet.page.html",
  styleUrls: ["./select-staking-wallet.page.scss"],
})
export class SelectStakingWalletPage implements OnInit {
  wallets: Array<any> = [];
  selectedWallet: any;
  fromFiat: boolean;

  asset: any;

  constructor(
    private modalCtrl: ModalController,
    public navParams: NavParams,
    public api: ApiService,
    private walletHelper: WalletHelperService
  ) {
    this.fromFiat = this.navParams.get("fromFiat");
    this.wallets = this.navParams.get("fromWallets");
    this.asset = this.api.stakingV2Asset;
  }

  ngOnInit() {}

  closeModal() {
    this.modalCtrl.dismiss(null);
  }

  /**
   * select Wallet
   * @param wallet_id
   */
  selectWallet(wallet: any) {
    this.selectedWallet = wallet;
    let data = {
      selectedWallet: this.selectedWallet,
    };
    this.modalCtrl.dismiss(data);
  }
}
